import { logCSAUserAction } from './logUserAction';
import { IAttachmentLocalComputerFilePicker } from 'owa-attachment-filepicker';

export const onAddInlineImage = (
    computerAttachmentPicker: React.RefObject<IAttachmentLocalComputerFilePicker>
) => {
    return () => {
        const key = 'AddInlineImage';
        computerAttachmentPicker.current?.click();
        logCSAUserAction(key, { key });
    };
};
